// extracted by mini-css-extract-plugin
module.exports = {"warning":"reverification_failed_warning___cwyK"};